import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { BaseHttpService } from '@shared/infrastructure/services/http/base-http.service';
import { environment } from '@env/environment';
import { LocationApiDTO } from '../dto/location.api.dto';
import { DrawerApiDTO } from '@features/service/infrastructure/dto/drawer.api.dto';
import { WorkerApiDTO } from '../dto/worker.api.dto';
import { ServiceRelationsApiDTO } from '../dto/relation.api.dto';

@Injectable({ providedIn: 'root' })
export class HttpLocationGateway extends BaseHttpService {
  protected readonly baseUrl = environment.apiURL;

  getLocations(): Observable<LocationApiDTO[]> {
    return this.get<LocationApiDTO[]>('/api/v2/locations').pipe(
      catchError((error) => {
        this.logger.error(
          new Error('[HttpServiceGateway][getLocations] Error fetching locations from server'),
          error
        );

        return of([]);
      })
    );
  }

  getDrawers(): Observable<DrawerApiDTO[]> {
    return this.get<DrawerApiDTO[]>('/api/v2/cash-drawers').pipe(
      catchError((error) => {
        this.logger.error(
          new Error('[HttpServiceGateway][getDrawers] Error fetching drawers from server'),
          error
        );

        return of([]);
      })
    );
  }

  getWorkers(): Observable<WorkerApiDTO[]> {
    return this.get<WorkerApiDTO[]>('/api/v2/workers').pipe(
      catchError((error) => {
        this.logger.error(
          new Error('[HttpServiceGateway][getWorkers] Error fetching workers from server'),
          error
        );

        return of([]);
      })
    );
  }

  getRelations(): Observable<ServiceRelationsApiDTO> {
    return this.get<ServiceRelationsApiDTO>('/api/v2/service-configurations/relations').pipe(
      catchError((error) => {
        this.logger.error(
          new Error('[HttpServiceGateway][getRelations] Error fetching relations from server'),
          error
        );

        return of({
          locationsToCashDrawers: {},
          cashDrawersToWorkers: {},
          workersToLocations: {},
        });
      })
    );
  }
}
